import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesCategory} from './citizens-services-category.model';

export const loadCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Load CitizensServicesCategorys',
  props<{ citizensServicesCategorys: CitizensServicesCategory[] }>()
);

export const addCitizensServicesCategory = createAction(
  '[CitizensServicesCategory/API] Add CitizensServicesCategory',
  props<{ citizensServicesCategory: CitizensServicesCategory }>()
);

export const upsertCitizensServicesCategory = createAction(
  '[CitizensServicesCategory/API] Upsert CitizensServicesCategory',
  props<{ citizensServicesCategory: CitizensServicesCategory }>()
);

export const addCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Add CitizensServicesCategorys',
  props<{ citizensServicesCategorys: CitizensServicesCategory[] }>()
);

export const upsertCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Upsert CitizensServicesCategorys',
  props<{ citizensServicesCategorys: CitizensServicesCategory[] }>()
);

export const updateCitizensServicesCategory = createAction(
  '[CitizensServicesCategory/API] Update CitizensServicesCategory',
  props<{ citizensServicesCategory: Update<CitizensServicesCategory> }>()
);

export const updateCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Update CitizensServicesCategorys',
  props<{ citizensServicesCategorys: Update<CitizensServicesCategory>[] }>()
);

export const deleteCitizensServicesCategory = createAction(
  '[CitizensServicesCategory/API] Delete CitizensServicesCategory',
  props<{ id: string }>()
);

export const deleteCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Delete CitizensServicesCategorys',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesCategorys = createAction(
  '[CitizensServicesCategory/API] Clear CitizensServicesCategorys'
);


//CUSTOM
export const citizenGetCategories = createAction(
  '[CitizensServicesCategory/API] citizen Get all Categories',
);

